import { PackageOpenIcon } from "lucide-react";
import { Loading } from "@/components/ui/loading";
import { cn } from "@/lib/utils";

type Props = {
	title?: string;
	children?: React.ReactNode;
	className?: string;
};

export const EmptyFallback = ({ title, children, className }: Props) => (
	<div className={cn("flex h-full flex-col items-center justify-center text-center leading-6", className)}>
		<PackageOpenIcon className="mb-2 size-10" />
		<p className="font-bold text-2xl">{title || "No hay contenido disponible"}</p>

		<div className="max-w-xl">
			{children || (
				<p className="max-w-lg">
					Actualmente no hay contenido disponible para mostrar. Por favor, revisa más tarde para nuevas actualizaciones.
				</p>
			)}
		</div>
	</div>
);

export const ErrorFallback = ({ title, children, className }: Props) => (
	<div className={cn("flex h-full flex-col items-center justify-center text-center leading-6", className)}>
		<p className="font-bold text-2xl">{title || "Error al cargar contenido"}</p>
		<div className="max-w-xl">
			{children || (
				<p className="max-w-lg">
					Lo sentimos, ha ocurrido un error al cargar el contenido. Por favor, inténtalo de nuevo más tarde.
				</p>
			)}
		</div>
	</div>
);

export const LoadingFallback = ({ title, children }: Props) => (
	<div className="flex h-full flex-col items-center justify-center leading-6">
		<Loading className="mb-6" />
		<p className="font-bold text-2xl">{title || "Cargando… Gracias por tu paciencia"}</p>

		<div>{children || <p className="text-center">Estamos preparando todo para ti. Solo tomará un momento más.</p>}</div>
	</div>
);
